export const formatNumber = (value: number) => {
  return Number(value).toFixed(2);
};